<template>
  <div class="registration-page">
    <div class="registration-page-container" v-if="(this.$store.state.connectedCar.common.imei+'').length < 1 && this.entrLoc == ''">
      <div class="section">
        <div class="section-header">
          <h3>배송지</h3>
        </div>
        <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              <label>정보확인</label>
            </dt>
            <dd class="field-control">
              <div id=" " class="input-container">
                <input
                  id="chceck-03-01"
                  v-model="retrieveData.addressCopyFlag"
                  @click="addressCopy"
                  type="checkbox"
                  name=""
                  class="input-checkbox input-text"
                />
                <label for="chceck-03-01" class="input-label"
                  >위 가입자 정보와 동일</label
                >
              </div>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label">
              <label>수취인명</label>
            </dt>
            <dd class="field-control">
              <input
                v-model="retrieveData.dlvRcipNm"
                type="text"
                @input="onlyText"
                name="dlvRcipNm"
                autocomplete="off"
                class="input-text input-font"
                title="수취인 성명 입력"
              />
            </dd>
          </dl>

          <dl class="field-group">
            <dt class="field-label">
              고객주소
            </dt>
            <dd class="field-control">
              <div class="field-control-sub m-input-half">
                <input
                  type="text"
                  v-model="retrieveData.dlplZpcd"
                  name="postCode"
                  class="input-text input-width-xsmall input-font input-text-disabled"
                  placeholder="우편번호"
                  readonly
                  title="우편번호"
                />
                <span class="field-group-space"></span>
                <button
                  @click="zipcodeAddressPop"
                  title="새창열림"
                  type="button"
                >
                  주소찾기
                </button>
              </div>
              <div class="field-control-sub">
                <input
                  type="text"
                  v-model="retrieveData.dlplBadr"
                  name="address1"
                  class="input-text input-width-xlarge input-font input-text-disabled"
                  readonly
                  title="주소"
                />
              </div>
              <div class="field-control-sub">
                <input
                  type="text"
                  v-model="retrieveData.dlplDadr"
                  name="address2"
                  class="input-text input-width-xlarge input-font input-text-disabled"
                  readonly
                  title="주소"
                />
              </div>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label">
              <label for="">수취인 연락처1</label>
            </dt>
            <dd class="field-control">
              <input
                type="text"
                @input="onlyNumber"
                v-model="retrieveData.dlplTlno"
                name=""
                autocomplete="off"
                class="input-text input-font"
                maxlength="11"
                placeholder="'-' 없이 숫자만 입력"
                title="수취인 기본 연락처 입력"
              />
            </dd>
          </dl>
        </div>
      </div>
    </div>
    <ZipcodeDirectPopup @close="popupClose" />
    <v-dialog />
  </div>
</template>

<script>
import ZipcodeDirectPopup from '../../openMarket/popup/ZipcodeDirectPopup'
export default {
  name: 'ConnectedCarShipToAddrSectionn',
  props: {},
  components: {
    ZipcodeDirectPopup
  },
  data() {
    return {
      retrieveData: {
        dlvRcipNm: '',
        dlplZpcd: '',
        dlplBadr: '',
        dlplDadr: '',
        dlplTlno: '',
        addressCopyFlag: ''
      },
      entrLoc: ''
    }
  },
  mounted(){
    this.entrLoc = this.$store.state.connectedCar.common.entrLoc
  },
  computed: {},
  methods: {
    /** 
     * Function    : validShipToAddr
     * Description : 배송지 정보 필수값 Validation
     **/
    validShipToAddr() {
      let title = '배송지정보'
      if (!this.retrieveData.dlvRcipNm) {
        this.openAlert(title, '수취인명을 입력하세요')
        return false
      }
      if (!this.retrieveData.dlplBadr) {
        this.openAlert(title, '고객주소를 입력하세요')
        return false
      }
      if (!this.retrieveData.dlplDadr) {
        this.openAlert(title, '고객상세주소를 입력하세요')
        return false
      }
      if (!this.retrieveData.dlplTlno) {
        this.openAlert(title, '수취인연락처1를 입력하세요')
        return false
      }
      return true
    },

    /** 
     * Function    : onlyNumber
     * Description : input값 숫자 체크
     **/
    onlyNumber(e) {
      this.retrieveData[e.target.name] = e.target.value.replace(/[^0-9]/gi, '')
    },

    /** 
     * Function    : onlyText
     * Description : input값 텍스트 체크
     **/
    onlyText(e) {
      this.retrieveData[e.target.name] = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
    },

    /** 
     * Function    : openAlert
     * Description : 기본 alert 호출 함수
     **/
    openAlert(title, message) {
      this.$modal.show('dialog', {
        title: title,
        text: message,
        buttons: [
          {
            title: '확인',
            class: 'primary-button'
          }
        ]
      })
    },

    /** 
     * Function    : zipcodeAddressPop
     * Description : 우편번호 조회 팝업 호출
     **/
    zipcodeAddressPop() {
      this.$store.state.zipType = 'customer'
      this.$modal.show('zipcodeAddress')
    },

    /** 
     * Function    : popupClose
     * Description : 우편번호 팝업 닫힐 시 이벤트
     **/
    popupClose(result) {
      if (result.id === 'ok') {
        this.retrieveData.dlplZpcd = result.ok.zip
        this.retrieveData.dlplBadr = result.ok.addr1
        this.retrieveData.dlplDadr = result.ok.addrDetail
      }
    },

    /** 
     * Function    : addressCopy
     * Description : 위 가입자와 동일 시 주소 정보 복사
     **/
    addressCopy() {
      if (!this.retrieveData.addressCopyFlag) {
        this.retrieveData.addressCopyFlag = 'Y'
        this.retrieveData.dlvRcipNm = this.$store.state.connectedCar.address.dlvRcipNm
        this.retrieveData.dlplZpcd = this.$store.state.connectedCar.address.dlplZpcd
        this.retrieveData.dlplBadr = this.$store.state.connectedCar.address.dlplBadr
        this.retrieveData.dlplDadr = this.$store.state.connectedCar.address.dlplDadr
        this.retrieveData.dlplTlno = this.$store.state.connectedCar.address.dlplTlno
      } else {
        this.retrieveData.addressCopyFlag = ''
        this.retrieveData.dlvRcipNm = ''
        this.retrieveData.dlplZpcd = ''
        this.retrieveData.dlplBadr = ''
        this.retrieveData.dlplDadr = ''
        this.retrieveData.dlplTlno = ''
      }
    }
  }
}
</script>

<style scoped></style>
